import { connect } from 'react-redux';

import { getPermissions } from '../Login/selectors';
import {
  getAudioGenerationQueueStats,
  updateAudioGeneration,
} from './actionSagas';
import AudioGenerationQueue from './AudioGenerationQueue';
import { getAudioGenerationQueueData } from './selectors';

const mapStateToProps = (state) => ({
  audioGenerationQueueData: getAudioGenerationQueueData(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  getQueueData: () => dispatch(getAudioGenerationQueueStats()),
  updateAudioGeneration: (action) => dispatch(updateAudioGeneration(action)),
});

const AudioGenerationQueueContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AudioGenerationQueue);

export default AudioGenerationQueueContainer;
